// @ts-nocheck

import { ReportActionTypes } from '../types/actions/report';

export const sendReport = (data: unknown = {}) => ({
  type: ReportActionTypes.SEND,
  payload: data,
});

export default {
  sendReport,
};
